module.exports = __webpack_public_path__ + "img/LR.6dfca5e5.svg";